import React from 'react';
import StockReportFunctional from './components/stock-report-list-functional';
import './stock-report.scss';

const StockReport = () => {
	return <StockReportFunctional />;
};

export default StockReport;
